/**
 * 관리자 회원 현황
 * ($j.Pages.Admin.MemberCurrent / body data-page-name="MemberCurrent")
 *
 * 현재 정상회원 구성(구분·경로·지역·장비[유료/무료]) + 업체발주자 본사별 + 안드로이드 OS + 앱별 앱버전.
 */
import Util from '../../Common/Util';

export default class MemberCurrent {
    constructor() {
        this.palette = ['#0d6efd', '#198754', '#fd7e14', '#6610f2', '#20a8a8', '#dc3545', '#6c757d', '#e83e8c'];
        this.detail = { os: [], sido: [] };          // 모달용 전체 리스트
        this.detailTitle = { os: '안드로이드 OS 전체', sido: '지역(시도) 전체' };
        this.verApps = [];                           // 앱별 앱버전 (모달은 code 로 찾는다)
    }

    initialize() {
        $('#mcRefresh').on('click', () => this._load(true));
        $('[data-detail]').on('click', (e) => this._openDetail($(e.currentTarget).data('detail')));
        // 앱버전 카드는 응답을 받고 나서 그리므로 위임으로 건다
        $('#mcVerRow').on('click', '[data-ver-app]', (e) => this._openVerDetail($(e.currentTarget).data('ver-app')));
        // 앱버전 막대 클릭 → 해당 버전 회원목록 모달. 막대는 카드/전체보기 모달 양쪽에 나오므로 document 위임.
        $(document).on('click', '.mc-ver-bar', (e) => {
            const $b = $(e.currentTarget);
            this._openVersionMembers($b.data('app-code'), String($b.data('ver')));
        });
        // 가입경로/지역/본사별 막대 클릭 → 회원목록 모달. 마찬가지로 전체보기 모달에도 나오므로 document 위임.
        $(document).on('click', '.mc-bd-bar', (e) => {
            const $b = $(e.currentTarget);
            this._openBreakdownMembers($b.data('bd-kind'), String($b.data('bd-value')), String($b.data('bd-label')));
        });
        this._load();
    }

    async _load(nocache = false) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/members/current', type: 'get',
                data: nocache ? { nocache: 1 } : {}
            });
            if (!res.ok) return;
            $('#mcTotal').text(this._c(res.total));
            $('#mcPaid').text(this._c(res.paid_total));
            const pct = res.total > 0 ? Math.round(res.paid_total / res.total * 100) : 0;
            $('#mcPaidPct').text(`전체의 ${pct}%`);
            this._renderActive(res.active);
            this._bars('#mcByType', res.by_type, null, 'type');
            this._bars('#mcByPath', res.by_path, null, 'path');
            this.detail.sido = res.by_sido || [];
            this._bars('#mcBySido', this.detail.sido, 10, 'sido');
            this._renderCar(res.by_car);
            this._bars('#mcByBonsa', res.by_bonsa, null, 'bonsa');

            this.detail.os = res.device_os || [];
            this._bars('#mcByOs', this.detail.os, 6, 'os');
            this._renderVerApps(res.device_ver);

            if (res.cached_at) $('#mcCachedAt').text(`집계 ${res.cached_at}`);
        } catch (e) {
            console.error('회원 현황 로드 실패', e);
        }
    }

    /** 장비별 — 전체 표시, 유료>0 일 때만 "(유료 N)" 부기 */
    _renderCar(items) {
        const list = items || [];
        if (!list.length) { $('#mcByCar').html('<span class="text-muted small">없음</span>'); return; }
        const max = Math.max(...list.map(i => i.count));
        const html = list.map(i => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const paidW = i.count > 0 ? Math.round(i.paid / i.count * 100) : 0;
            const paidTxt = i.paid > 0 ? ` <span style="color:var(--adm-c-0d6efd, #0d6efd)">(유료 ${this._c(i.paid)})</span>` : '';
            // 유료 겹막대라 _barsHtml 을 못 쓴다 — 클릭 속성(.mc-bd-bar)만 같은 규약으로 붙인다
            return `<div class="row-item mc-bd-bar" data-bd-kind="car" data-bd-value="${this._escAttr(i.label)}" data-bd-label="${this._escAttr(i.label)}" style="cursor:pointer;" title="클릭하면 회원목록">
                <span class="lbl">${this._escAttr(i.label)}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:#ced4da;position:relative;">
                    <span style="position:absolute;left:0;top:0;height:100%;width:${paidW}%;background:#0d6efd;border-radius:3px;"></span>
                </span>
                <span class="val"><b>${this._c(i.count)}</b>${paidTxt}</span>
            </div>`;
        }).join('');
        $('#mcByCar').html(html);
    }

    /**
     * 앱별 앱 버전 — 장비불러 / 머큐리 / 악덕알리미 카드 3장.
     * 세 장 모두 같은 막대그래프(_barsHtml)다 — 상위 6개, 넘으면 '자세히' 로 전체.
     */
    _renderVerApps(apps) {
        this.verApps = apps || [];
        if (!this.verApps.length) { $('#mcVerRow').empty(); return; }

        const html = this.verApps.map(a => {
            const more = (a.items && a.items.length > 6)
                ? `<button class="btn btn-xs btn-outline-secondary ml-auto" data-ver-app="${a.code}">자세히</button>` : '';
            return `<div class="col-md-4">
                <div class="card h-100">
                    <div class="card-header d-flex align-items-center">
                        <span>앱 버전 — ${this._escAttr(a.label)}</span>${more}
                    </div>
                    <div class="card-body">${this._verBarsHtml(a.items, a.code, 6)}</div>
                </div>
            </div>`;
        }).join('');
        $('#mcVerRow').html(html);
    }

    _openVerDetail(code) {
        const app = this.verApps.find(a => a.code === code);
        if (!app) return;
        const html = `<div class="ms-bd" style="padding:4px 2px;">${this._verBarsHtml(app.items, app.code)}</div>`;
        $j.Ui.JBModal.html('mc-detail-modal', html, `앱 버전 — ${this._escAttr(app.label)}`, { width: '420px' });
    }

    /** 앱버전 회원목록 모달 — 그래프 막대(카드/전체보기 모달 공용) 클릭 시. 페이징(10개)+검색 DataTable. */
    async _openVersionMembers(code, ver) {
        const app = this.verApps.find(a => a.code === code);
        const appLabel = app ? app.label : code;
        try {
            const res = await $.ajax({ url: '/adm/ajax/stat/members/version', type: 'get', data: { code, ver } });
            if (!res.ok) return;
            const rows = res.data || [];
            const tblId = 'mc-ver-members-tbl';
            const html = `<div style="padding:4px 2px;"><table id="${tblId}" class="table table-sm table-bordered display" style="width:100%;"></table></div>`;
            $j.Ui.JBModal.html('mc-ver-members-modal', html, this._escAttr(`${appLabel} ${ver} · ${this._c(rows.length)}명`), { width: '620px' });

            if (this.$verMemTable) { try { this.$verMemTable.destroy(); } catch (e) { /* noop */ } this.$verMemTable = null; }
            if (!document.getElementById(tblId)) return;
            this.$verMemTable = new DataTable(`#${tblId}`, {
                data: rows,
                columns: [
                    { data: 'mem_name', title: '이름', render: (v, t, r) => this._verNameCell(v, r) },
                    { data: 'mem_car_type', title: '장비', render: (v) => Util.escapeHtml(v || '-') },
                    { data: 'sido', title: '지역', render: (v) => Util.escapeHtml(v || '-') },
                    { data: 'device_os', title: 'OS', render: (v) => Util.escapeHtml(v || '-') },
                    { data: 'last_seen', title: '최근 접속', render: (v) => Util.escapeHtml(v || '-') },
                ],
                order: [], // 서버 정렬(이름순) 유지
                pageLength: 10,
                lengthChange: false,
                searching: true,
                autoWidth: false,
                language: { emptyTable: '없음' },
            });
        } catch (e) {
            console.error('앱버전 회원목록 로드 실패', e);
        }
    }

    _verNameCell(v, r) {
        const testBadge = r.is_test ? ' <span class="badge badge-secondary">테스트</span>' : '';
        return $j.F.Admin.Member.Pop.cell(r.mb_no, v) + testBadge;
    }

    /** 가입경로/지역/본사별 회원목록 모달 — 그래프 막대(카드/전체보기 모달 공용) 클릭 시. 페이징(10개)+검색 DataTable. */
    async _openBreakdownMembers(kind, value, label) {
        const titleMap = { type: '회원구분', path: '가입경로', sido: '지역(시도)', car: '장비종류', bonsa: '본사(소속)', os: '안드로이드 OS' };
        try {
            const res = await $.ajax({ url: '/adm/ajax/stat/members/breakdown', type: 'get', data: { kind, value } });
            if (!res.ok) return;
            const rows = res.data || [];
            const tblId = 'mc-bd-members-tbl';
            const html = `<div style="padding:4px 2px;"><table id="${tblId}" class="table table-sm table-bordered display" style="width:100%;"></table></div>`;
            $j.Ui.JBModal.html('mc-bd-members-modal', html, this._escAttr(`${titleMap[kind] || kind} · ${label} · ${this._c(rows.length)}명`),
                { width: kind === 'os' ? '620px' : '560px' });

            if (this.$bdMemTable) { try { this.$bdMemTable.destroy(); } catch (e) { /* noop */ } this.$bdMemTable = null; }
            if (!document.getElementById(tblId)) return;
            const nameCol = { data: 'mem_name', title: '이름', render: (v, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, v) };
            const carCol = { data: 'mem_car_type', title: '장비', render: (v) => Util.escapeHtml(v || '-') };
            const sidoCol = { data: 'sido', title: '지역', render: (v) => Util.escapeHtml(v || '-') };
            const loginCol = { data: 'last_login', title: '최근 로그인', render: (v) => Util.escapeHtml(v || '-') };
            const seenCol = { data: 'last_seen', title: '최근 접속', render: (v) => Util.escapeHtml(v || '-') };
            // 업체발주자(본사별)는 장비가 의미 없으니 빼고 최근로그인을, OS 는 기기 기준이라 최근접속을 넣는다.
            // 나머지(구분/경로/지역/장비)는 이름·장비·지역 그대로.
            const columns = kind === 'bonsa' ? [nameCol, sidoCol, loginCol]
                          : kind === 'os'    ? [nameCol, carCol, sidoCol, seenCol]
                          : [nameCol, carCol, sidoCol];
            this.$bdMemTable = new DataTable(`#${tblId}`, {
                data: rows,
                columns,
                order: [], // 서버 정렬(이름순) 유지
                pageLength: 10,
                lengthChange: false,
                searching: true,
                autoWidth: false,
                language: { emptyTable: '없음' },
            });
        } catch (e) {
            console.error('회원목록 로드 실패', e);
        }
    }

    _renderActive(a) {
        if (!a) return;
        $('#auDau').text(this._c(a.dau));
        $('#auWau').text(this._c(a.wau));
        $('#auMau').text(this._c(a.mau));
        $('#auStick').text(a.stickiness + '%');
    }

    _openDetail(kind) {
        const items = this.detail[kind] || [];
        // 전체보기 모달의 막대도 카드와 같이 클릭하면 회원목록이 뜬다 (kind 가 곧 필터축)
        const html = `<div class="ms-bd" style="padding:4px 2px;">${this._barsHtml(items, null, kind)}</div>`;
        $j.Ui.JBModal.html('mc-detail-modal', html, this.detailTitle[kind] || '전체', { width: '420px' });
    }

    _bars(sel, items, limit, kind) {
        $(sel).html(this._barsHtml(items, limit, kind));
    }

    /**
     * 막대그래프 공통 렌더. kind 를 주면(path/sido/bonsa) 막대가 클릭 가능해지고
     * document 위임(.mc-bd-bar)이 _openBreakdownMembers 로 회원목록 모달을 띄운다.
     * 필터값은 항목에 code 가 있으면(본사별) code, 없으면 label 을 그대로 쓴다.
     */
    _barsHtml(items, limit, kind) {
        if (!items || !items.length) return '<span class="text-muted small">없음</span>';
        const list = limit ? items.slice(0, limit) : items;
        const total = items.reduce((a, b) => a + b.count, 0);
        const max = Math.max(...list.map(i => i.count));
        return list.map((i, idx) => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const pct = total > 0 ? Math.round(i.count / total * 100) : 0;
            const color = this.palette[idx % this.palette.length];
            const cls = kind ? ' mc-bd-bar' : '';
            const attrs = kind
                ? ` data-bd-kind="${kind}" data-bd-value="${this._escAttr(i.code != null ? i.code : i.label)}" data-bd-label="${this._escAttr(i.label)}" style="cursor:pointer;" title="클릭하면 회원목록"`
                : '';
            return `<div class="row-item${cls}"${attrs}>
                <span class="lbl" title="${this._escAttr(i.label)}">${this._escAttr(i.label)}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:${color}"></span>
                <span class="val">${this._c(i.count)} (${pct}%)</span>
            </div>`;
        }).join('');
    }

    // 라벨은 기기가 보내온 값(앱 버전·OS)이나 회원 입력에서 온다 — 본문·속성 양쪽에 쓰므로 전부 이스케이프
    _escAttr(v) {
        return Util.escapeHtml(v);
    }

    /** _barsHtml 과 같은 막대이지만 앱버전 전용 — 클릭하면 회원목록 모달. */
    _verBarsHtml(items, code, limit) {
        if (!items || !items.length) return '<span class="text-muted small">없음</span>';
        const list = limit ? items.slice(0, limit) : items;
        const total = items.reduce((a, b) => a + b.count, 0);
        const max = Math.max(...list.map(i => i.count));
        return list.map((i, idx) => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const pct = total > 0 ? Math.round(i.count / total * 100) : 0;
            const color = this.palette[idx % this.palette.length];
            return `<div class="row-item mc-ver-bar" data-app-code="${code}" data-ver="${this._escAttr(i.label)}" style="cursor:pointer;" title="클릭하면 회원목록">
                <span class="lbl" title="${this._escAttr(i.label)}">${this._escAttr(i.label)}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:${color}"></span>
                <span class="val">${this._c(i.count)} (${pct}%)</span>
            </div>`;
        }).join('');
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {
        $(document).off('click', '.mc-ver-bar');
        $(document).off('click', '.mc-bd-bar');
        if (this.$verMemTable) { try { this.$verMemTable.destroy(); } catch (e) { /* noop */ } this.$verMemTable = null; }
        if (this.$bdMemTable) { try { this.$bdMemTable.destroy(); } catch (e) { /* noop */ } this.$bdMemTable = null; }
        $j.Ui.JBModal.close();
    }
}
